import React, { forwardRef } from 'react';
import { SwipeableCardHandle } from '../base/SwipeableCard';
import { type ActionCardProps, ActionCardInner } from './ActionCardInner';
import { ActionCardErrorBoundary } from './ActionCardErrorBoundary';

/**
 * ActionCard wraps the inner implementation with a Sentry error boundary
 */
export const ActionCard = forwardRef<SwipeableCardHandle, ActionCardProps>((props, ref) => {
  const { action } = props;

  return (
    <ActionCardErrorBoundary appointment={action}>
      <ActionCardInner {...props} ref={ref} />
    </ActionCardErrorBoundary>
  );
});

// Add display name for better debugging
ActionCard.displayName = 'ActionCard';
